import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from '@/router/index';
import LoginModal from '@/components/common/LoginModal';
import Welcome from '@/components/common/LoginModal/welcome';
import WechatBrowserBanner from '@/components/common/WechatBrowserBanner';
import BrandDebugSwitch from '@/components/common/BrandDebugSwitch';
import authService from '@/services/amai/auth.service';
import { spaceManager } from '@/services/space/spaceManager';
import { hasToken, setUserInfo as saveUserInfo, isHandler, isGift } from '@/utils/auth';
import { eventBus } from '@/utils/eventBus';

const GlobalLoginWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showWelcome, setShowWelcome] = useState(false);
 
  useEffect(() => {
    //如果未true则出发登录组件
    if (isHandler()) {
      eventBus.emit('showLoginModal')
    }
    if (!hasToken()) return;

    authService.getUserProfile().then((response) => {
      if (response.code === 0) {
        saveUserInfo(response.data);
        // 持久化个人 user_id（画布 creator_user_id 只读比对、切回个人时交换 target 用）。
        // 团队 token（t_）下 profile 同样返回 personal_user_id 且语义即个人身份 id
        // （20261030 主公实测证实），必须记录：否则团队身份进画布时 personalUserId 为空，
        // creatorReadOnly 恒 false，只读闸门（右键菜单/编辑入口）全部失效。
        // 防脏写交给 recordPersonalUserId（teamId 拒录）
        if (response.data.personal_user_id) {
          spaceManager.recordPersonalUserId(response.data.personal_user_id);
        }
        eventBus.emit('userInfoUpdated', response.data);
        if (response.data.show_new_user_gift) {
          // H5路由使用自己的领取弹窗，不显示PC版
          const isH5Route = window.location.pathname.startsWith('/h5/');
          if (!isH5Route) {
            setShowWelcome(true);
          }
        }
      }
    }).catch((error) => {
      console.error('[App] 获取用户信息失败:', error);
    });

    const handleShowWelcome = () => {
      const isH5Route = window.location.pathname.startsWith('/h5/');
      if (!isH5Route) {
        setShowWelcome(true);
      }
    };
    eventBus.on('showWelcome', handleShowWelcome);
    return () => {
      eventBus.off('showWelcome', handleShowWelcome);
    };


  }, []);

  return (
    <>
      <WechatBrowserBanner />
      {children}
      <LoginModal />
      {showWelcome && <Welcome onClose={() => setShowWelcome(false)} />}
      {/* 开发/测试环境：品牌模拟切换（模拟 aifilm.gxzs.top 形态） */}
      <BrandDebugSwitch />
    </>
  );
};

const App: React.FC = () => {
  return (
    <GlobalLoginWrapper>
      <RouterProvider router={router} future={{ v7_startTransition: true } as any} />
    </GlobalLoginWrapper>
  );
};

export default App;